/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import {Box} from '@mui/material'
import React from 'react'
import Localization from './Localization'
import Timezones from './Timezones'
import {SxProps} from '@mui/system'

const LanguageAndTime: React.FC<{sx?: SxProps}> = ({sx}) => {
  return (
    <Box flexDirection={'column'} sx={sx}>
      <Localization />
      <Timezones />
    </Box>
  )
}

export default LanguageAndTime
